export default __webpack_public_path__ + "static/media/count2.ea65cfce.jpg";